
import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';

//import pages
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';


const App = () => {

  return <div className='overflow-hidden'>
    <Router>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/privacy' element={<PrivacyPolicy />} />
          <Route path='/terms' element={<Terms />} />
        </Routes>
      </Router>
  </div>;
};

export default App;